import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatTargetRate } from '@/shared/lib/utils';
import { StatTile } from '@/shared/ui';

/** Лучшая устойчивая пара «возражение × аргумент» для KPI-блока. */
export type BestPair = {
  objectionLabel: string;
  argumentLabel: string;
  rate: number;
};

type Props = {
  /** Всего диалогов в выборке */
  totalDialogs: number;
  /** Доля цели по всей выборке (0..1) или null */
  baselineRate: number | null;
  /** Лучшая устойчивая пара или null, если таких нет */
  bestPair: BestPair | null;
};

/**
 * Строка ключевых показателей матрицы: объём выборки, базовая доля цели
 * и лучшая устойчивая пара.
 */
export const MatrixKpis: FC<Props> = ({ totalDialogs, baselineRate, bestPair }) => {
  const { t } = useTranslation('strategist');

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <StatTile label={t('kpi.totalDialogs')}>{totalDialogs.toLocaleString()}</StatTile>
      <StatTile label={t('kpi.baseline')}>{formatTargetRate(baselineRate)}</StatTile>
      <StatTile label={t('kpi.bestPair')}>
        {bestPair === null ? (
          '—'
        ) : (
          <span className="flex flex-col">
            <span className="text-sm font-medium text-foreground line-clamp-1">
              {`${bestPair.objectionLabel} → ${bestPair.argumentLabel}`}
            </span>
            <span className="text-sm text-muted-foreground">{formatTargetRate(bestPair.rate)}</span>
          </span>
        )}
      </StatTile>
    </div>
  );
};
